module.exports = __webpack_public_path__ + "static/media/xerologo.d4da1980.svg";